export default function ProgressText({ progressText = "", progress }) {
  return (
    <div className="flex items-center gap-3 animate-moveFromTop">
      {(typeof progress === "number" && progress === 100) || !progress ? (
        <svg width="12" height="12" viewBox="0 0 20 20">
          <path
            d="M20 6L9 17L4 12"
            className="fill-none stroke-primary-tint stroke-[2]"
          ></path>
        </svg>
      ) : (
        <svg width="10" height="12">
          <circle cx="5" cy="7" r="5" className=" fill-primary-tint">
            {progress ? (
              <animate
                attributeName="opacity"
                values="1;0.4;1"
                dur="2s"
                repeatCount="indefinite"
              />
            ) : null}
          </circle>
        </svg>
      )}
      <p
        className={`text-xs tracking-wide ${
          (typeof progress === "number" && progress === 100) || !progress
            ? "font-semibold"
            : "font-normal"
        }`}
      >
        {progressText}{" "}
        {typeof progress === "number" && progress ? `(${progress}%)` : null}
      </p>
    </div>
  );
}
